module.exports = __webpack_public_path__ + "static/media/ce-authbg.19d31a71.jpg";